<template>
    <div class="merged-page">
        <AppBreadCrumb :paths="[{ title: $t('message.users') }]" :select="true">
            <a-input-search
                :value="searchText"
                @input="searchTextHandle($event)"
                :placeholder="$t('message.startFilter')"
                class="search-input"
                @search="onSearch"
            />
            <a-button
                class="actionButtonBreadcrumb"
                @click="openCreateModal"
                v-if="checkPermission(PERMISSION_TYPES['user.create'].tr.name)"
            >
                <md-icon>add</md-icon>
                {{ $t("message.newUser") }}
            </a-button>
        </AppBreadCrumb>
        <UpgradeNeeded v-if="showUpgrade" @close="showUpgrade = false" @show-plans="showSupsisPlans">
            Maximun Temsilci sayısına ulaştınız. Maximun <b>{{ getMaxAgent() }}</b> Temsilci oluşturabilirsiniz.
            Paketinizi yenileyerek dilediğiniz gibi temsilci sayısını yükseltebilirsiniz.
        </UpgradeNeeded>
        <div style="background-color: #ffffff" class="d-flex w-100">
            <div class="side-menubar-wrapper" style="width: 15%">
                <UsersMenu />
            </div>
            <div id="users">
                <b-container class="mb-3" fluid>
                    <a-alert
                        v-if="getAgentCredit() <= 0"
                        :message="$t('message.planInfoHeader')"
                        class="mt-2"
                        type="info"
                    >
                        <div slot="description" class="d-flex flex-column">
                            <div class="d-flex align-items-center">
                                <a-icon type="info-circle" />
                                <span class="p-1 text-info ml-1">
                                    {{
                                        $t("message.planInformation", {
                                            selectedPlan: getCurrentPlanName(),
                                            detailMaxAgentCount: getMaxAgent(),
                                            freeAgent: getFreeAgentCredit(),
                                        })
                                    }}
                                </span>
                            </div>

                            <span class="p-1 text-info mt-1">
                                {{ $t("message.creditAvailable") }} <b>{{ getAgentCredit() }}</b> .
                                {{ $t("message.upDownGradePlan") }}
                                <button
                                    id="btn-change-plan"
                                    style="
                                        border-radius: 15%;
                                        border: none;
                                        background-color: lightskyblue;
                                        font-size: larger;
                                    "
                                    @click="$router.push('/billing')"
                                >
                                    <b>{{ $t("message.click") }}</b>
                                </button>
                            </span>
                        </div>
                    </a-alert>
                    <a-table
                        :key="'vtable-' + renderCount"
                        :columns="cols()"
                        :dataSource="getFilteredRows()"
                        :loading="isBusy"
                        :locale="{
                            emptyText: $t('message.noNewUser'),
                        }"
                        :pagination="false"
                        class="custom-table2"
                        rowKey="_id"
                        @change="tableChange"
                    >
                        <div
                            :key="'nameSlot' + $i18n.locale"
                            :slot="'nameSlot'"
                            slot-scope="data, item"
                            v-tippy="{
                                followCursor: true,
                                placement: 'top-right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="item.name"
                        >
                            {{ item.name.length > 15 ? item.name.slice(0, 11) + "..." : item.name }}
                        </div>
                        <div :key="'roleSlot' + $i18n.locale" :slot="'roleSlot'" slot-scope="data, item">
                            {{ null != item.role ? item.role.name : "-" }}
                        </div>
                        <div
                            :key="'departmentSlot' + $i18n.locale"
                            :slot="'departmentSlot'"
                            slot-scope="data, item"
                            v-tippy="{
                                followCursor: true,
                                placement: 'top-right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="getUserDepartmentNames(item)"
                            class="departmentSlot"
                        >
                            {{ getUserDepartmentNames(item) }}
                        </div>
                        <div :key="'enableStateSlot' + $i18n.locale" :slot="'enableStateSlot'" slot-scope="data, item">
                            <a-icon v-if="item.enable" class="text-success" type="check" />
                            <a-icon v-else class="text-danger" type="close" />
                        </div>
                        <div
                            :key="'lastLoginPlatformSlot' + $i18n.locale"
                            :slot="'lastLoginPlatformSlot'"
                            slot-scope="data, item"
                        >
                            <div v-if="item.lastLoginPlatform === 'mobile'" class="mr-2 text-primary">
                                <a-icon type="mobile" />
                                Mobile
                            </div>
                            <div v-else>
                                <a-icon class="mr-2 text-primary" type="chrome" />
                                WEB
                            </div>
                        </div>
                        <div :key="'statusSlot' + $i18n.locale" :slot="'statusSlot'" slot-scope="data, item">
                            <span
                                v-if="item.isOnline"
                                :class="statuses.find((s) => s.status === item.status).class"
                                class="st-item onlineMode"
                            >
                                <font-awesome-icon
                                    :icon="statuses.find((s) => s.status === item.status).icon"
                                    class="mr-2"
                                />
                                {{ $t(statuses.find((s) => s.status === item.status).langKey) }}
                            </span>
                            <span
                                v-else
                                :class="statuses.find((s) => s.status === item.status).class"
                                class="st-item offlineMode"
                            >
                                <font-awesome-icon
                                    :icon="statuses.find((s) => s.status === item.status).icon"
                                    class="mr-2"
                                />
                                {{ $t(statuses.find((s) => s.status === item.status).langKey) }}
                            </span>
                        </div>
                        <div :key="'actionsSlot' + $i18n.locale" :slot="'actionsSlot'" slot-scope="data, item">
                            <div class="d-flex w-100 justify-content-start">
                                <a-button
                                    class="actionButton d-flex align-items-center"
                                    @click="edit(item._id)"
                                    v-if="checkPermission(PERMISSION_TYPES['user.update'].tr.name)"
                                >
                                    <ActionEdit />
                                </a-button>
                                <span v-if="checkPermission(PERMISSION_TYPES['user.delete'].tr.name)">
                                    <a-button
                                        v-if="item._id !== loggedUser._id"
                                        :disabled="users.total === 1"
                                        class="actionButton d-flex align-items-center"
                                        @click="remove(item._id)"
                                    >
                                        <ActionDelete />
                                    </a-button>
                                </span>
                                <a-button
                                    v-if="item._id !== loggedUser._id"
                                    :disabled="users.total === 1"
                                    class="actionButton d-flex align-items-center"
                                    @click="startDM(item._id)"
                                >
                                    <dm-icon />
                                </a-button>
                            </div>
                        </div>
                    </a-table>
                    <div class="mt-3 d-flex justify-content-end">
                        <Pagination
                            :page-change="pageChange"
                            :page-sizes="pageSizes"
                            :total="users.total"
                            pageSizeLocalStorageKey="users-page-size"
                        />
                    </div>
                </b-container>
                <div
                    class="fab d-flex justify-content-center align-items-center"
                    @click="openCreateModal"
                    v-if="checkPermission(PERMISSION_TYPES['user.create'].tr.name)"
                >
                    <md-icon class="">add</md-icon>
                </div>
                <Modal2
                    v-if="isModalShow"
                    id="user-form"
                    :title="editMode ? $t('message.updateUserForm') : $t('message.newUserForm')"
                    :show-footer="false"
                    @cancel="hideModal"
                >
                    <a-alert
                        v-if="$validator.errors.items.length && submitClicked"
                        :message="$t('message.error')"
                        class="mb-2"
                        showIcon
                        type="error"
                    >
                        <div slot="description">
                            <div v-for="err of $validator.errors.items">
                                <span>
                                    {{ err.msg }}
                                </span>
                            </div>
                        </div>
                    </a-alert>
                    <b-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
                        <b-row>
                            <b-col md="12">
                                <b-row>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('message.username')) != null,
                                            }"
                                        >
                                            <label>{{ $t("message.username") }}</label>
                                            <md-input
                                                v-model="user.name"
                                                v-validate="'required'"
                                                :name="$t('message.username')"
                                                type="text"
                                                :placeholder="$t('message.username')"
                                                autocomplete="off"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("message.username")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('message.email')) != null,
                                            }"
                                        >
                                            <label>{{ $t("message.email") }}</label>
                                            <md-input
                                                v-model="user.email"
                                                v-validate="{
                                                    required: true,
                                                    regex: /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,}(\.\w{2,4})?$/,
                                                }"
                                                :name="$t('message.email')"
                                                autocomplete="off"
                                                trim
                                                type="email"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("message.email")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="12" v-if="shouldShowContent && editMode">
                                        <md-field>
                                            <label>Şifre Güncelle</label>
                                            <div style="display: contents">
                                                <md-input
                                                    v-model="user.password"
                                                    :name="$t('message.username')"
                                                    type="password"
                                                    :placeholder="'Şifre Güncelle'"
                                                    autocomplete="off"
                                                />
                                            </div>
                                        </md-field>
                                    </b-col>
                                    <b-col v-if="!editMode" md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('message.password')) != null,
                                            }"
                                        >
                                            <label>{{ $t("message.password", { num: "6" }) }}</label>
                                            <md-input
                                                :ref="$t('message.password')"
                                                v-model="user.password"
                                                v-validate="editMode ? 'min:6' : 'required|min:6'"
                                                :name="$t('message.password')"
                                                :placeholder="
                                                    $t('message.passwordAtLeast', {
                                                        num: '6',
                                                    })
                                                "
                                                autocomplete="off"
                                                trim
                                                type="password"
                                            ></md-input>
                                            <span class="md-error">{{ errors.first($t("message.password")) }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col v-if="!editMode" md="6">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('message.passwordRepeat')) != null,
                                            }"
                                        >
                                            <label>{{ $t("message.passwordRepeat") }}</label>
                                            <md-input
                                                v-model="passwordConfirmation"
                                                v-validate="
                                                    editMode
                                                        ? 'confirmed:' + $t('message.password') + '|min:6'
                                                        : 'required|confirmed:' + $t('message.password') + '|min:6'
                                                "
                                                :name="$t('message.passwordRepeat')"
                                                autocomplete="off"
                                                type="password"
                                            ></md-input>
                                            <span class="md-error">{{
                                                errors.first($t("message.passwordRepeat"))
                                            }}</span>
                                        </md-field>
                                    </b-col>
                                    <b-col md="6" v-if="checkPermission(PERMISSION_TYPES['role.get'].tr.name)">
                                        <b-form-group
                                            id="role-input-group"
                                            :label="$t('message.role')"
                                            label-for="role-input"
                                        >
                                            <a-select
                                                v-model="user.role"
                                                v-validate="'required'"
                                                :default-value="user.role"
                                                :filter-option="filterOption"
                                                :name="$t('message.role')"
                                                :placeholder="$t('message.selectARole')"
                                                option-filter-prop="children"
                                                show-search
                                                style="width: 100%"
                                            >
                                                <a-select-option :value="undefined">
                                                    {{ $t("message.selectARole") }}
                                                </a-select-option>
                                                <a-select-option v-for="r of roles.data" :key="r._id" :value="r._id">
                                                    {{ r.name }}
                                                </a-select-option>
                                            </a-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group
                                            id="lang-input-group"
                                            :label="$t('message.language')"
                                            label-for="lang-input"
                                        >
                                            <a-select
                                                v-model="user.lang"
                                                v-validate="'required'"
                                                :default-value="user.lang"
                                                :filter-option="filterOption"
                                                option-filter-prop="children"
                                                show-search
                                                :name="$t('message.language')"
                                                style="width: 100%"
                                            >
                                                <a-select-option v-for="(r, ii) of languages" :value="r.code" :key="ii">
                                                    {{ r.label }}
                                                </a-select-option>
                                            </a-select>
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="12">
                                        <md-field
                                            :class="{
                                                'md-invalid': errors.first($t('message.autoChatAssignLimit')) != null,
                                            }"
                                        >
                                            <label name="auto-assign">{{ $t("message.autoChatAssignLimit") }}</label>
                                            <md-input
                                                id="auto-assign-limit-input"
                                                v-model="user.autoAssignLimit"
                                                :name="$t('message.autoChatAssignLimit')"
                                                autocomplete="off"
                                                class="mt-2"
                                                min="-1"
                                                type="number"
                                            ></md-input>
                                            <span class="md-error">{{
                                                errors.first($t("message.autoChatAssignLimit"))
                                            }}</span>
                                        </md-field>
                                        <small>-{{ $t("message.chatAssignInfo") }}</small>
                                    </b-col>
                                    <b-col md="12">
                                        <div>
                                            <label class="typo__label">{{ $t("message.relatedDepartments") }}</label>
                                            <multiselect
                                                v-model="selectedDepartments"
                                                :multiple="true"
                                                :options="getSubjectOptions()"
                                                :placeholder="$t('message.relatedDepartments')"
                                                label="text"
                                                track-by="value"
                                            ></multiselect>
                                        </div>
                                    </b-col>
                                    <b-col md="12">
                                        <div class="d-flex justify-content-start align-items-center">
                                            <label>{{ $t("message.status") }}</label>
                                            <md-switch
                                                v-model="switchButton"
                                                :disabled="loggedUser._id === user._id"
                                                class="md-primary ml-3"
                                            >
                                                <span v-if="user.enable">{{ $t("message.active") }}</span>
                                                <span v-else>{{ $t("message.passive") }}</span>
                                            </md-switch>
                                        </div>
                                    </b-col>
                                    <b-col md="12">
                                        <b-button :disabled="loading" type="submit" variant="primary">
                                            <template v-if="!loading">
                                                <span v-if="!editMode">{{ $t("message.save") }}</span>
                                                <span v-else>{{ $t("message.update") }}</span>
                                            </template>
                                            <template v-else>
                                                <font-awesome-icon icon="spinner" spin />
                                            </template>
                                        </b-button>
                                        <b-button @click="hideModal">
                                            <template> {{ $t("message.cancel") }}</template>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-form>
                </Modal2>
            </div>
        </div>
        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faCheckCircle,
    faClock,
    faGlobeEurope,
    faMinusCircle,
    faPencilAlt,
    faPlusCircle,
    faPowerOff,
    faSpinner,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { log2 } from "../../utils/log2";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import * as _ from "lodash";
import ChatBar from "../../components/ChatBar";
import UsersMenu from "./UsersMenu";
import { sendSocketMessage } from "../../utils/socketStream";
import { tableSorter } from "../../utils/utils";
import Pagination from "../../components/Pagination";
import ActionEdit from "../../components/svg/ActionEdit";
import ActionDelete from "../../components/svg/ActionDelete";
import Multiselect from "vue-multiselect";
import { USER_API } from "../../api/user";
import languages from "../../language/languages.json";
import { getPersistenceData } from "../../utils/persistenceStorage";
import Modal2 from "../../components/common/Modal2.vue";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import dmIcon from "../../components/svg/DmIcon.vue";
import SYSTEM_PUBSUB from "../../utils/systemPubSub";
import UpgradeNeeded from "../../components/UpgradeNeeded.vue";

library.add(
    faPencilAlt,
    faTimes,
    faPlusCircle,
    faSpinner,
    faCheckCircle,
    faClock,
    faMinusCircle,
    faPowerOff,
    faGlobeEurope
);

const userInitialObject = {
    _id: null,
    username: "",
    email: "",
    password: "",
    role: undefined,
    subjects: [],
    autoAssignLimit: -1,
    enable: true,
    lang: "tr",
};
const log = log2("Users");
export default {
    name: "Users",
    components: {
        AppBreadCrumb,
        ChatBar,
        Pagination,
        ActionEdit,
        ActionDelete,
        Multiselect,
        UsersMenu,
        Modal2,
        dmIcon,
        UpgradeNeeded,
    },
    data() {
        return {
            languages,
            lastFetchTS: Date.now(),
            isBusy: true,
            getTimerId: null,
            loading: false,
            submitClicked: false,
            user: _.cloneDeep(userInitialObject),
            searchText: this.$route.query.searchText || undefined,
            editMode: false,
            passwordConfirmation: "",
            pageSizes: ["10", "25", "50", "100"],
            switchButton: true,
            statuses: [
                {
                    status: "Online",
                    langKey: "message.online",
                    class: "online",
                    icon: "check-circle",
                    order: 1,
                },
                {
                    status: "Away",
                    langKey: "message.beRightBack",
                    class: "away",
                    icon: "clock",
                    order: 2,
                },
                {
                    status: "Busy",
                    langKey: "message.busy",
                    class: "busy",
                    icon: "minus-circle",
                    order: 3,
                },
                {
                    status: "Offline",
                    langKey: "message.offline",
                    class: "offline",
                    icon: "power-off",
                    order: 4,
                },
            ],
            cols: () => [
                {
                    dataIndex: "name",
                    index: "name",
                    title: this.$t("message.username"),
                    scopedSlots: { customRender: "nameSlot" },
                    ...tableSorter("name", "string", this.currentSort),
                },
                {
                    dataIndex: "email",
                    title: this.$t("message.email"),
                    ...tableSorter("email", "string", this.currentSort),
                },
                {
                    dataIndex: "enable",
                    title: this.$t("message.enableState"),
                    scopedSlots: { customRender: "enableStateSlot" },
                    ...tableSorter("enable", "string", this.currentSort),
                },
                {
                    dataIndex: "status",
                    title: this.$t("message.status"),
                    scopedSlots: { customRender: "statusSlot" },
                    ...tableSorter("status", "string", this.currentSort),
                },
                {
                    dataIndex: "lastLoginPlatform",
                    title: "Platform",
                    scopedSlots: { customRender: "lastLoginPlatformSlot" },
                    ...tableSorter("lastLoginPlatform", "string", this.currentSort),
                },
                {
                    dataIndex: "role",
                    title: this.$t("message.role"),
                    scopedSlots: { customRender: "roleSlot" },
                    ...tableSorter("role", "string", this.currentSort),
                },
                {
                    dataIndex: "subjects",
                    title: this.$t("message.departments"),
                    scopedSlots: { customRender: "departmentSlot" },
                    ...tableSorter("subjects", "array_len", this.subjects),
                },
                {
                    title: this.$t("message.transactions"),
                    scopedSlots: { customRender: "actionsSlot" },
                    width: "10%",
                },
            ],
            perPage: !isNaN(getPersistenceData("users-page-size") || "undefined")
                ? parseInt(getPersistenceData("users-page-size"))
                : 1000,
            page: 1,
            renderCount: 0,
            currentSort: {
                columnKey: this.$route.query.columnKey || "name",
                order: this.$route.query.order || "ascend",
            },
            users: {
                total: 0,
                count: 0,
                data: [],
            },
            selectedDepartments: [],
            activeUserCount: null,
            isModalShow: false,
            queryAction: this.$route.query.action,
            showUpgrade: false,
        };
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            userPassword: (state) => state.auth.user,
            /*users: state => state.user.users,*/
            roles: (state) => state.role.roles,
            plan: (state) => _.get(state.setting.settings, "plan"),
            settings: (state) => state.setting.settings,
            subjects: (state) => state.subject.subjects.data,
            loggedUser: (state) => state.auth.user || state.auth.adminUser,
            site: (state) => state.site.site,
            isAdmin: (state) => state.auth.adminUser != null,
            currentPlans: (state) => state.site.currentPlans,
            plans: (state) =>
                state.site.plans.reduce((acc, plan) => {
                    acc[plan._id] = plan;
                    return acc;
                }, {}),
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            checkPermission: "auth/checkPermission",
        }),
        isPermissionsEmpty() {
            return this.userPassword.role.permissions.length === 0;
        },
        shouldShowContent() {
            return this.isAdmin || this.isPermissionsEmpty;
        },
    },
    methods: {
        ...mapActions({
            getUser: "user/getUser",
            getUsers: "user/getUsers",
            getRoles: "role/getRoles",
            createUser: "user/createUser",
            updateUser: "user/updateUser",
            deleteUser: "user/deleteUser",
        }),
        startDM(id) {
            this.$router.push("/chat?tabIndex=6");
            setTimeout(() => {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.START_AGENT_CHAT, { userId: id });
            }, 500);
        },
        closeModal() {
            this.isModalShow = false;
        },
        async hideModal() {
            await this.reset();
            await this.closeEditMode();
            this.closeModal();
        },
        showModal() {
            this.isModalShow = true;
        },
        closeEditMode() {
            this.editMode = false;
        },
        getSubjectOptions() {
            return this.subjects.map((p) => {
                const validLangs = Object.keys(p.languageContent);
                const lang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
                return {
                    text: _.get(p, `languageContent.${lang}.name`),
                    value: p._id,
                };
            });
        },
        getUserDepartmentNames(user) {
            return (user.subjects || []).length
                ? this.subjects
                      .filter((x) => (user.subjects || []).includes(x._id))
                      .map(
                          (x) =>
                              _.get(x, `languageContent.${this.$i18n.locale}.name`) ||
                              _.get(x, `languageContent.${Object.keys(x.languageContent)[0]}.name`)
                      )
                      .join(",")
                      .toLowerCase()
                : this.$t("message.allDepartments");
        },
        tableChange(pagination, filters, sorter) {
            log("tableChange", { pagination, filters, sorter });
            this.perPage = pagination.pageSize;
            log("tableChange", { pagination, filters, sorter });
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            log("show me current Sort", {
                currentSort: this.currentSort,
                newSort,
            });
            if (!_.isEqual(newSort, oldSort)) {
                log("sorting changed rendering", { newSort, oldSort });
                this.currentSort = newSort;
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        getFilteredRows() {
            return this.users.data;
        },
        pageChange(page, pageSize) {
            log("pageChange", { page, pageSize });
            this.page = page;
            this.perPage = pageSize;
        },
        onShowSizeChange(current, pageSize) {
            log("onShowSizeChange", current, pageSize);
            this.page = current;
            this.perPage = pageSize;
        },
        updateActiveAgentCount() {
            USER_API.fetchActiveUserCount().then((activeAgentCount) => {
                this.activeUserCount = activeAgentCount;
            });
        },
        debouncedGet(getRoles = false, showLoading = true, interval = 2000) {
            if (!!this.getTimerId) clearTimeout(this.getTimerId);
            this.getTimerId = setTimeout(() => {
                this.get(getRoles, showLoading);
            }, interval);
        },
        showSupsisPlans() {
            this.$router.push("/billing/plans/supsis");
        },
        get(getRoles = false, showLoading = true) {
            if (showLoading) this.isBusy = true;
            const query = this.searchText === "" && this.searchText == null ? undefined : this.searchText;
            /*const query = undefined;*/
            const pagination = { perPage: this.perPage, page: this.page };
            const sorting = {
                sortBy: this.currentSort.columnKey,
                sortOrder: this.currentSort.order,
            };
            this.updateQueryParams("columnKey", sorting.sortBy);
            this.updateQueryParams("order", sorting.sortOrder);
            this.updateQueryParams("page", pagination.page);
            this.updateQueryParams("perPage", pagination.perPage);
            this.updateQueryParams("searchText", query);
            this.getUsers({
                perPage: pagination.perPage,
                page: pagination.page,
                query,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder,
                updateStore: false,
            })
                .then((x) => {
                    log.debug("users fetched", x);
                    if (!_.isEqual(this.users, x.data)) {
                        this.users = x.data;
                    }

                    if (getRoles) {
                        this.getRoles({ perPage: 100, page: 1 });
                    }
                })
                .finally(() => {
                    if (showLoading) this.isBusy = false;
                    this.lastFetchTS = Date.now();
                    if (this.queryAction == "create") this.openCreateModal();
                });
            this.updateActiveAgentCount();
        },
        updateQueryParams(key, value) {
            if (value === "" || value == null) {
                let query = Object.assign({}, this.$route.query);
                delete query[key];
                this.$router.replace({ query });
            } else {
                let { query } = this.$route;
                this.$router.replace({
                    query: { ...query, [key]: encodeURI(value) },
                });
            }
        },
        getCurrentPlanName() {
            const plan = this.plans[this.currentPlans["supsis"].plan.planId];
            return plan ? `${plan.title} ${plan.altTitle}` : "Supsis Free";
        },
        getFreeAgentCredit() {
            const features = Object.keys(this.currentPlans).reduce((acc, type) => {
                const plan = this.plans[this.currentPlans[type]?.plan?.planId];
                if (plan) acc.push(...plan.features);
                return acc;
            }, []);
            const agentFeatures = features.filter((feature) => feature.type == "agent");
            const freeAgentCount = agentFeatures.reduce((acc, feature) => acc + (+feature.freeAgentCount || 0), 0);
            return freeAgentCount;
        },
        getMaxAgent() {
            const plan = this.currentPlans["supsis"]?.plan;
            const credit = plan ? plan.details.agentCount : 1;
            return credit;
        },
        getAgentCredit() {
            const maxAgent = this.getMaxAgent();
            const freeAgent = this.getFreeAgentCredit();
            return Math.max(maxAgent + freeAgent - this.activeUserCount, 0);
        },
        openCreateModal() {
            if (this.getAgentCredit() <= 0) {
                this.showUpgrade = true;
                return;
            }
            this.user.name = "Supsis";
            this.user.email = "supsis@gmail.com";
            this.selectedDepartments = [];
            this.showModal();
            this.editMode = false;
            //this.$bvModal.show("user-form");
        },
        edit(id) {
            log("edit", id);
            const maybeUser = this.users.data.find((x) => x._id === id);
            if (maybeUser) {
                this.editMode = true;
                this.user = _.cloneDeep(maybeUser);
                if (typeof this.user.role === "object") this.user.role = this.user.role._id;
                this.user.password = "";
                this.switchButton = this.user.enable;
                log("updating user", this.user);

                this.selectedDepartments = this.subjects
                    .filter((x) => this.user.subjects.includes(x._id))
                    .map((p) => ({
                        text:
                            _.get(p, `languageContent.${this.$i18n.locale}.name`) ||
                            _.get(p, `languageContent.${Object.keys(p.languageContent)[0]}.name`),
                        value: p._id,
                    }));
                this.showModal();
                //this.$bvModal.show("user-form");
            }
        },
        remove(id) {
            this.$dialog
                .confirm(this.$t("message.douYouWishToDeleteUser"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    this.deleteUser(id)
                        .then((res) => {
                            log("deleteUser response", res);
                            this.get(true);
                            const socketMessageId = this.isAdmin ? "admin user-delete" : "user user-delete";
                            sendSocketMessage(socketMessageId, {
                                deletingUserId: id,
                                userId: this.loggedUser._id,
                                siteId: this.site._id,
                            });

                            this.$toasted.show(this.$t("message.userDeleted"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        })
                        .catch((err) => {
                            console.error(err);
                            this.$toasted.show("User delete error", {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        });
                });
        },
        reset() {
            log("reset");
            this.user = _.cloneDeep(userInitialObject);
            this.submitClicked = null;
            this.passwordConfirmation = "";
        },
        handleSave() {
            log("handleSave");
            this.submitClicked = true;
            if (this.getAgentCredit() === 0 && this.switchButton && !this.user.enable) {
                return this.openCreateModal();
            }
            this.user.enable = this.switchButton;
            return this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    const result = this.user._id
                        ? this.updateUser({ user: this.user, siteId: this.site._id })
                        : this.createUser(this.user);
                    const operation = this.user._id ? "update" : "create";

                    result
                        .then(() => {
                            log("operation completed", { operation });
                            this.$toasted.show(this.$t("message.userSaved"), {
                                duration: 3000,
                                position: "bottom-center",
                            });

                            if (operation === "update") {
                                const socketMessageId = this.isAdmin ? "admin user-updated" : "user user-updated";
                                sendSocketMessage(socketMessageId, {
                                    userId: this.user._id,
                                    siteId: this.site._id,
                                });
                            }
                            this.reset();
                            this.get();
                            sendSocketMessage("team refresh-chats", {
                                siteId: this.site._id,
                            });
                        })
                        .catch((err) => {
                            log.error(err.response, err.message);
                            const errMsg =
                                err.response && err.response.data && err.response.data.localizedMessages
                                    ? err.response.data.localizedMessages[this.$i18n.locale]
                                    : err.message;
                            this.$toasted.error(errMsg, {
                                duration: 4000,
                                position: "bottom-center",
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                            this.submitClicked = false;
                            this.hideModal();
                        });
                } else {
                    this.loading = false;
                }
            });
        },

        searchTextHandle(e) {
            this.searchText = e.target.value;
        },
        onSearch() {
            this.debouncedGet(false, true, 0);
        },
    },

    mounted() {
        log("mounted");
        this.get(true);
        this.timerId = setInterval(() => {
            const tookTime = Date.now() - this.lastFetchTS;
            if (tookTime > 5000) {
                this.debouncedGet(false, false, 0);
            }
        }, 5000);
    },

    beforeDestroy() {
        if (this.timerId) clearInterval(this.timerId);
    },

    updated() {
        if (this.$validator.locale !== this.$i18n.locale) this.$validator.localize(this.$i18n.locale);
    },
    watch: {
        page(newValue, oldValue) {
            if (newValue) {
                this.debouncedGet(false, true, 0);
            }
        },
        perPage(newValue, oldValue) {
            if (newValue) {
                this.debouncedGet(false, true, 0);
            }
        },
        searchText(newValue, oldValue) {
            this.debouncedGet();
        },
        currentSort(newValue, oldValue) {
            if (newValue) {
                this.debouncedGet(false, true, 0);
            }
        },
        selectedDepartments(newValue) {
            this.user.subjects = newValue.map((x) => x.value);
        },
        // settings(old, newValue) {
        //     this.updateActiveAgentCount();
        // },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.ant-table-column-title {
    color: #181c32;
    font-size: 13px;
    font-weight: 300;
    font-family: Poppins;
    white-space: nowrap;
}

.custom-tabs .nav.nav-tabs {
    position: absolute;
    top: 49px;
    left: 30px;
    right: 30px;
    z-index: 123;
}

.merged-page {
    position: relative;

    .custom-breadcrumb {
        margin-bottom: 1px;
    }
}

.departmentSlot {
    max-width: 100px;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 40px;
    white-space: nowrap;
}

.new-theme {
    #users {
        min-height: 90vh;
        width: 85%;
        background: #eef0f8;

        .actionButton {
            border: none;
            box-shadow: none;
        }
    }
}

.fab {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    background-color: white;
    position: absolute;
    bottom: 20px;
    left: 17.5%;
    z-index: 9999;
    transition: all 0.3s;
    box-shadow: 0 0 0 0 rgba(100, 100, 100, 1);
    transform: scale(1);
    animation: pulse 3s infinite;
    cursor: pointer;
}

#btn-change-plan > a > b:hover {
    color: whitesmoke;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(100, 100, 100, 0.5);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px #00000000;
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 #00000000;
    }
}
</style>
